import MultiSelect from './MultiSelect.tsx'

export type MultiOption = {
  value: string
  text: string
  field: string
  selected: boolean
}
export default function SelectInputs({
  label,
  startWhenEmptyValue,
  multiOptions,
  defaultSelected,
  selectedInputsValues,
  setSelectedInputsValues,
  canSelectMoreThanOne = true
}: {
  label: string
  startWhenEmptyValue?: string
  multiOptions: MultiOption[]
  defaultSelected: string[]
  selectedInputsValues: string[]
  setSelectedInputsValues: React.Dispatch<React.SetStateAction<string[]>>
  canSelectMoreThanOne?: boolean
}) {
  return (
    <div className="space-y-6">
      <div>
        <MultiSelect
          label={label}
          options={multiOptions}
          defaultSelected={defaultSelected}
          onChange={(values) => setSelectedInputsValues(values)}
          startWhenEmptyValue={startWhenEmptyValue}
          canSelectMoreThanOne={canSelectMoreThanOne}
        />
        <p className="sr-only">
          Selected Values: {selectedInputsValues.join(', ')}
        </p>
      </div>
    </div>
  )
}
